export default {
  createTitle: "Doktor Hozzáadása",
  updateTitle: "Doktor Módosítása",
  action: {
    recoveryKeyDownload: 'Regisztrációs kód letöltése',
    register: "Regisztrálás",
    sendInvite: 'Meghívó küldése',
  },
  modal: {
    inviteTitle: "Orvosok Meghívása",
    registerTitle: "Orvosok Meghívása",
    registerDisclaimer: "A tesztüzem ideje alatt a rendszer automatikusan kiküld egy ideiglenes jelszót a meghívott fél e-mail címére. A tesztüzem után ez a folyamat meg fog változni.",
    invitationDisclaimer: "A tesztüzem ideje alatt a rendszer automatikusan kiküld egy ideiglenes jelszót a meghívott fél e-mail címére. A tesztüzem után ez a folyamat meg fog változni.",
  },
  fields: {
    name: "Orvos neve",
    contactPhone: "Telefonszám",
    contactEmail: "E-mail",
    address: "Levelezési cím",
    manager: "Menedzser",
    exportLock: "Exportálási korlátozás"
  },
  exportLock: {
    none: "Nincs",
    neak: "NEAK",
    pharmacy: "Gyártói",
    developer: "Fejlesztő és karbantartói"
  }
}
